import { Box, IconButton, useTheme } from "@mui/material";
import { ArrowLeftIcon, RotateCcwIcon } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioFilterForm } from "web_myplann/Portfolio/Components/Redesign/Filter/PortfolioFilterForm";
import { useFilterForm } from "web_myplann/Portfolio/Components/Redesign/Filter/useFilterForm";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { isDefaultPortfolioFilter } from "web_myplann/Shared/State/portfolioFilterAtom";

export const PortfolioFilterPage: FC = () => {
	const { t } = useResource();
	const theme = useTheme();
	const navigate = useNavigate();
	const { form, onSubmit, reset } = useFilterForm();

	const values = form.watch();
	const showReset = !isDefaultPortfolioFilter(values);

	return (
		<MyPlannLayout
			disableContentPadding
			disableBottomBarSpacing
			bgColor={theme.palette.grey[50]}
			topBarBgColor={theme.palette.background.paper}
			topBar={
				<MyPlannTopBarRedesign
					title={t(Resources.Portfolio.List.Redesign.Filter.title)}
					startComponent={
						<IconButton
							variant="header"
							onClick={() => navigate(Routing.Portfolio.PortfolioList.path())}
						>
							<ArrowLeftIcon
								size={theme.iconSize.md}
								color={theme.palette.grey[600]}
							/>
						</IconButton>
					}
					endComponent={
						showReset ? (
							<IconButton
								variant="header"
								onClick={reset}
								aria-label={t(Resources.Portfolio.List.Redesign.Filter.reset)}
							>
								<RotateCcwIcon size={18} color={theme.palette.blue.main} />
							</IconButton>
						) : undefined
					}
				/>
			}
		>
			<Box minHeight="100%" bgcolor={theme.palette.grey[50]}>
				<PortfolioFilterForm form={form} onSubmit={onSubmit} />
			</Box>
		</MyPlannLayout>
	);
};
